import React from 'react';
import { Flex } from 'rebass';
import FormStepLabel from './FormStepLabel';

const FormStepLabels: React.FC<any> = ({ showLabels, formStep }) =>
  showLabels && (
    <Flex width="100%" justifyContent="space-between" mt={13}>
      <FormStepLabel active>Job posting overview</FormStepLabel>
      <FormStepLabel active={formStep >= 2}>Job requirements</FormStepLabel>
      <FormStepLabel active={formStep >= 3}>Interview process</FormStepLabel>
      <FormStepLabel active={formStep === 4}>Information for recruiters</FormStepLabel>
    </Flex>
  );

export default FormStepLabels;
